import _extends from "@babel/runtime/helpers/extends";
import { SwitchProductModule } from '@wix/package-picker-sdk';
import React from 'react';
import { useCurrentModule } from '../components';
import { EclipseCta } from '../components/EclipseCta';
import { EclipsePackagePickerSteps } from '../types';
import { useViewChange } from './useViewChange';
import { useAnonymous } from './useAnonymous';
import { useDowngradeModalCallbacks } from './useDowngradeModalCallbacks';
import { useSelectPlanContext } from './SelectPlanContext';
export const useSelectButton = _ref => {
  let {
    productId,
    label,
    selectClickType,
    onSelectClick
  } = _ref;
  const module = useCurrentModule();
  const {
    t
  } = module.internals.useTranslations();
  const handleViewChange = useViewChange();
  const {
    isAnonymous
  } = useAnonymous();
  const {
    onSelectPlan
  } = useSelectPlanContext();
  const productAvailability = SwitchProductModule.SDK.hooks.useProductAvailability({
    productId
  });
  const isDisabled = !isAnonymous && !productAvailability.isLoading && !productAvailability.isProductAvailable;
  const text = label ?? t('productEntry.select');
  const disabledTooltipContent = t('Advanced.Plans_second.upgrade_plan.disabled.tooltip');
  const downgradeModalCallbacks = useDowngradeModalCallbacks();
  const showDowngradeModal = React.useCallback(() => {
    SwitchProductModule.SDK.modalsController.DowngradeModal.show({
      productId,
      callbacks: downgradeModalCallbacks
    });
  }, [productId, downgradeModalCallbacks]);
  const handleClick = React.useCallback(() => {
    onSelectClick == null || onSelectClick();
    module.internals.bi.onSelectPlan == null || module.internals.bi.onSelectPlan({
      productId,
      clickType: selectClickType ?? 'table'
    });
    if (onSelectPlan) {
      module.SDK.PackagePickerStore.setSelectedProductId(productId);
      onSelectPlan(productId);
      return;
    }
    if (productAvailability.isProductAvailable && productAvailability.canDowngrade) {
      showDowngradeModal();
      return;
    }
    module.internals.bi.onContinueToSelectCyclePage == null || module.internals.bi.onContinueToSelectCyclePage({
      productId,
      clickType: 'table'
    });
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    module.SDK.PackagePickerStore.setSelectedProductId(productId);
    handleViewChange(EclipsePackagePickerSteps.SELECT_CYCLE, {
      productId
    });
  }, [onSelectPlan, productId, productAvailability.isProductAvailable, productAvailability.canDowngrade, showDowngradeModal, module.internals.bi, selectClickType, onSelectClick]);
  const SelectButton = props => /*#__PURE__*/React.createElement(EclipseCta, _extends({
    onClick: handleClick,
    disabled: isDisabled,
    disabledTooltipContent: disabledTooltipContent
  }, props), text);
  return {
    SelectButton,
    isDisabled
  };
};
//# sourceMappingURL=useSelectButton.js.map